import { settings as settingsAtom } from '@/lib/store'
import { useAtom } from 'jotai'

export default function useSettings() {
  const [settings] = useAtom(settingsAtom)
  return settings
}
